var Item = /** @class */ (function () {
    function Item() {
        this.price = 0;
        this.name = "";
        this.quantity = 0;
        this.subItems = [];
    }
    Object.defineProperty(Item.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (v) {
            this._id = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Item.prototype, "totalPrice", {
        get: function () {
            var totalPrice = +(this.price * this.quantity).toFixed(2);
            return totalPrice;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Item.prototype, "price", {
        get: function () {
            return this._price;
        },
        set: function (v) {
            if (v < 0) {
                throw new Error("Price cannot be set to less than 0");
            }
            this._price = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Item.prototype, "name", {
        get: function () {
            return this._name;
        },
        set: function (v) {
            this._name = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Item.prototype, "quantity", {
        get: function () {
            return this._quantity;
        },
        set: function (v) {
            var vChecked = +v;
            if (isNaN(v)) {
                throw new Error("Quantity must be a valid number");
            }
            if (v < 0) {
                throw new Error("Quantity cannot be set to less than 0");
            }
            this._quantity = vChecked;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Item.prototype, "subItems", {
        get: function () {
            return this._subItems;
        },
        set: function (v) {
            if (v == null) {
                throw new Error("subItems cannot be null");
            }
            this._subItems = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Item.prototype, "assessment_uid", {
        get: function () {
            return this._assessment_uid;
        },
        set: function (value) {
            this._assessment_uid = value;
        },
        enumerable: true,
        configurable: true
    });
    return Item;
}());
export { Item };



// WEBPACK FOOTER //
// ./src/app/admin/models/item.ts.pre-build-optimizer.js